// "Wed 30 Sep, 4:20 PM": when a run started, in the reader's time zone, the way every run listing names a run.
const formatWorkflowRunStartedAt = (startedAtMs) => {
  if (!Number.isFinite(startedAtMs)) {
    return '—';
  }

  const parts = new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit'
  }).formatToParts(new Date(startedAtMs));
  const byType = Object.fromEntries(parts.map((part) => [part.type, part.value]));

  return `${byType.weekday} ${byType.day} ${byType.month}, ${byType.hour}:${byType.minute} ${byType.dayPeriod}`;
};

export default formatWorkflowRunStartedAt;
